/* s15i 01.10.2026 (власник): у швидкому підборі картки й фото з'являються разом.
   1. Усі кроки квізу є на сторінці від початку, але фото в них «ліниві» і вантажились лише тоді,
      коли крок ставав видимим. Після завантаження сторінки тихо підвантажуємо їх усі.
   2. Картки результату квіз малює скриптом. Новий блок із фото показуємо, коли фото вже готові,
      але не довше ніж за 0,6 с, щоб повільна мережа не тримала порожній екран. */
(function () {
  var root = document.getElementById("slQuiz");
  if (!root) return;
  function eager(scope) {
    [].forEach.call(scope.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = "eager"; });
  }
  function warm() { eager(root); }
  if (document.readyState === "complete") setTimeout(warm, 200);
  else window.addEventListener("load", function () {
    if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 1500 }); else setTimeout(warm, 300);
  });

  function ready(img) {
    if (img.complete && img.naturalWidth) return Promise.resolve();
    return new Promise(function (ok) { img.addEventListener("load", ok, { once: true }); img.addEventListener("error", ok, { once: true }); });
  }
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      [].forEach.call(m.addedNodes, function (n) {
        if (n.nodeType !== 1) return;
        var imgs = n.tagName === "IMG" ? [n] : [].slice.call(n.querySelectorAll("img"));
        if (!imgs.length) return;
        imgs.forEach(function (i) { if (i.loading === "lazy") i.loading = "eager"; });
        var wait = imgs.filter(function (i) { return !(i.complete && i.naturalWidth); });
        if (!wait.length || n.dataset.axImgWait) return;
        n.dataset.axImgWait = "1";
        var was = n.style.visibility;
        n.style.visibility = "hidden";
        var done = false, show = function () { if (done) return; done = true; n.style.visibility = was; delete n.dataset.axImgWait; };
        Promise.all(wait.map(ready)).then(show);
        setTimeout(show, 600);
      });
    });
  }).observe(root, { childList: true, subtree: true });
})();
